import { X } from 'lucide-react';
import { CHANNEL_TYPE_ICONS, CHANNEL_TYPE_META } from '../../lib/commsMeta';
import { notificationOrigin, notificationTitle, useNotifications } from './notifications';

/**
 * The toast stack (bottom-right, above the composer). Standalone only: framed,
 * the dashboard toasts every CRM notification itself, on every page including
 * this one, so the provider raises none here.
 * Clicking a toast opens the conversation and marks the notification read.
 */
export function NotificationToaster() {
  const { toasts, dismissToast, openNotification, hostedByDashboard } = useNotifications();
  if (hostedByDashboard || toasts.length === 0) return null;

  return (
    <div className="ntoasts">
      {toasts.map((notification) => {
        // The toast has no icon tile to hang a badge off (the bell's rows do),
        // so the channel's mark leads the line that already names it.
        const channelType = notification.snapshot.channelType ?? '';
        const ChannelMark = CHANNEL_TYPE_ICONS[channelType];
        const channelTone = CHANNEL_TYPE_META[channelType];
        return (
          <div key={notification.id} className="ntoast">
            <button
              type="button"
              className="ntoast-body"
              onClick={() => openNotification(notification)}
            >
              <span className="ntoast-title">{notificationTitle(notification)}</span>
              {notification.snapshot.preview && (
                <span className="ntoast-preview">{notification.snapshot.preview}</span>
              )}
              {/* Which line it landed on. Its own row rather than a fallback for a
                  missing preview: on a busy desk it is the part that decides
                  whether the toast is worth opening. */}
              <span className="ntoast-meta">
                {ChannelMark && channelTone && (
                  <ChannelMark size={11} style={{ color: channelTone.color }} />
                )}
                <span className="ntoast-origin">{notificationOrigin(notification)}</span>
              </span>
            </button>
            <button
              type="button"
              className="ntoast-close"
              aria-label="Dismiss"
              onClick={() => dismissToast(notification.id)}
            >
              <X size={13} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
